module.exports = __webpack_public_path__ + "static/media/Billete_sencillo_del_metro_(Madrid).6e6a6697.png";